import React, { useState, useEffect } from 'react';

const LoadingWindow = ({ setIsLoading }) => {
    const [filledBlocks, setFilledBlocks] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setFilledBlocks(prev => {
                if (prev < 14) return prev + 1;
                clearInterval(interval);
                setIsComplete(true); // defer setIsLoading
                return prev;
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    // Now call setIsLoading AFTER render phase is complete
    useEffect(() => {
        if (isComplete) {
            setIsLoading(false);
        }
    }, [isComplete, setIsLoading]);

    return (
        <div className='LoadingWindow'>
            <div className='LoadingWindowTitleBar'>
                <span className='Title'>System Message</span>
                <img src='/images/SystemMessageCloseButton.png' alt='Close' />
            </div>
            <div className='LoadingContent'>
                <span className='LoadingText'>LOADING....</span>
                <div className='LoadingBar'>
                    {Array.from({ length: 14 }).map((_, index) => (
                        <div
                            key={index}
                            className={`LoadingBlock ${index < filledBlocks ? 'filled' : ''}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LoadingWindow;
